module.exports = __webpack_public_path__ + "static/headerRightBg375-cbf9a1d97fa4d2c7f020b006847be16f.png";